import styled from 'styled-components'

const StartPageStyle = styled.article`
  margin: auto;

  .raks {
    font-family: 'Airwave-Regular';
    font-size: 36px;
    color: #424e60;
    margin: 0;
  }
  section {
    width: 1048px;
    height: 756px;
    background-color: ${props => props.theme.black4};
    display: grid;
    grid-template-rows: auto 1fr;
  }
  header {
    display: flex;
    justify-content: ${props =>
      props.licencja ? 'space-between' : 'flex-end'};
    padding: 12px 24px;
  }
  main {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  footer {
    display: flex;
    justify-content: space-between;
    margin-top: 8px;
  }

  footer .copyright {
    display: flex;
  }
  footer p {
    margin: 0;
  }
  .copyright p {
    margin-right: 4px;
  }
  a {
    text-decoration: none;
  }
  a:hover {
    color: ${props => props.theme.palette.primary.main};
  }

  .link {
    margin: 4px 0 16px 0;
    color: ${props => props.theme.palette.primary.main};
    cursor: pointer;
  }

  .watch {
    display: flex;
    align-items: center;
    justify-self: center;
    margin-bottom: 20px;
  }
  .icon {
    width: 36px;
    height: 36px;
    margin-left: 4px;
    margin-top: 4px;
    cursor: pointer;
  }

  h1 {
    color: ${props => props.theme.black60};
    margin: 24px 8px 0 8px;
    text-align: center;
  }

  h2 {
    color: ${props => props.theme.black60};
    margin: 0 8px 0 8px;
    text-align: center;
  }

  .imgContainer {
    border-radius: 50%;
    display: grid;
    justify-content: center;
    align-content: center;
    width: 56px;
    height: 56px;
    background: white;
    cursor: pointer;
    font-size: 24px;
    color: ${props => props.theme.black60};
  }

  h1 {
    font-family: Ubuntu;
    font-size: 48px;
  }

  h2 {
    font-size: 36px;
    font-weight: 300;
  }

  form {
    display: grid;
    width: 324px;
    margin-top: 24px;
  }

  fieldset {
    height: 72px;
  }

  main p {
    margin-top: 0;
    margin-bottom: 16px;
    /* text-align: center; */
  }

  .secondaryText {
    color: ${props => props.theme.black60};
    font-size: 16px;
    text-align: center;
    margin-top: 28px;
  }

  .firm {
    font-family: Ubuntu;
    font-size: 25px;
    color: ${props => props.theme.black60};
    line-height: 36px;
  }

  .licence {
    font-family: Ubuntu;
    font-size: 16px;
    color: ${props => props.theme.black60};
    line-height: 24px;
  }

  .buttons {
    display: flex;
  }

  .lastButton {
    margin-left: 8px;
  }

  .subheader {
    margin-top: 40px;
    text-align: center;
  }
`
export default StartPageStyle
